import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { NormasTeachingProductDTO } from "./useNormasTeachingProductById.ts";

/**
 * Flips the on-sale flag on its own endpoint rather than through the full
 * update, so toggling never round-trips — and never rewrites — the rest of the
 * product.
 */
export function useSetNormasTeachingProductEnabled() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const setNormasTeachingProductEnabled = async (
    productId: string,
    isEnabled: boolean,
  ): Promise<NormasTeachingProductDTO> => {
    try {
      setLoading(true);
      const { data } =
        await createAxiosInstance().post<NormasTeachingProductDTO>(
          `/products/${productId}/enabled`,
          { isEnabled },
        );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return { setNormasTeachingProductEnabled, loading };
}
